import * as Inovx from '@shared';
import AssemblyLibraryConstants from './../constants/AssemblyLibraryConstants';
import AssemblyLibraryServices from '../services/AssemblyLibraryServices';
import AssemblyLibraryStore from '../stores/AssemblyLibraryStore';
var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var FormHelper = Inovx.Shared.Common.FormHelper;
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

function _sendInvalidSave() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: AssemblyLibraryConstants.ASSEMBLY_TEMPLATE_INVALID_ADD
    });
}

var AssemblyLibraryActions = {
    beginAdd(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_LIBRARY_ADD
        });
    },
    beginEdit(data: IKnowledgeBook): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_LIBRARY_ADD,
            data
        });
    },
    openAssemblyLibrary(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.OPEN_ASSEMBLY_LIBRARY,
        });
    },
    closeAssemblyLibrary(): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.CLOSE_ASSEMBLY_LIBRARY,
        });
    },
    setAssemblyPosition(posiiton: IVector3D): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.SET_ASSEMBLY_POSITION,
            data: posiiton
        });
    },
    setAssemblyScale(scale: number): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.SET_ASSEMBLY_SCALE,
            data: scale
        });
    },
    setAssemblyTemplateHasChange(hasChange: boolean): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_HAS_CHANGE,
            data: hasChange
        });
    },
    setSelectedAssemblyTemplates(data: IAssemblyTemplate[]): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATES,
            data
        });
    },
    async getAssemblyLibraries() {
        const data = await AssemblyLibraryServices.getAssemblyLibraries();
        if (data.length > 0) data.sort((a, b) => a.Name.localeCompare(b.Name));
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_LIBRARIES,
            data
        });

        return data;
    },
    async getAssemblyLibrariesWithTemplates() {
        const data = await AssemblyLibraryServices.getAssemblyLibrariesWithTemplates();
        if (data.length > 0) {
            data.sort((a, b) => a.Name.localeCompare(b.Name));
            data.map((library) => {
                library.Templates.map((temp) => {
                    temp.ThumbnailImageUrl = (temp.ThumbnailImageUrl) ? UrlUtilities.getBaseApplicationUrl() + temp.ThumbnailImageUrl : null;
                    temp.GraphicsFileUrl = (temp.GraphicsFileUrl) ? UrlUtilities.getBaseApplicationUrl() + temp.GraphicsFileUrl : null;
                    return temp;
                })
                if (library.Templates.length > 0) library.Templates.sort((a, b) => a.Name.localeCompare(b.Name));
            })
        }
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_LIBRARIES_WITH_TEMPLATES,
            data
        });

        return data;
    },
    async createAssemblyLibrary(al: IAssemblyLibrary) {
        if (!SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_ADD)) {
            SystemActions.beginAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_ADD);

            try {

                let data = FormHelper.trim(al);
                var form_data: any = new FormData();
                form_data.append("Name", data.Name)

                const alRes: any = await AssemblyLibraryServices.createAssemblyLibrary(form_data);
                // refresh data
                return JSON.parse(alRes);
            }
            finally {
                SystemActions.endAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_ADD);
            }
        }

    },
    async deleteAssemblyLibrary(library: IAssemblyLibrary) {
        if (!SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_DELETE)) {
            SystemActions.beginAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_DELETE);
            try {
                await AssemblyLibraryServices.deleteAssemblyLibrary(library);
                AssemblyLibraryActions.setSelectedAssemblyLibrary('');
                await AssemblyLibraryActions.getAssemblyLibraries();
            }
            finally {
                SystemActions.endAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_DELETE);
            }
        }
    },
    async getAssemblyTemplates(LibraryID: string) {
        let data = await AssemblyLibraryServices.getAssemblyTemplates(LibraryID);
        data.map((temp) => {
            temp.ThumbnailImageUrl = (temp.ThumbnailImageUrl) ? UrlUtilities.getBaseApplicationUrl() + temp.ThumbnailImageUrl : null;
            temp.GraphicsFileUrl = (temp.GraphicsFileUrl) ? UrlUtilities.getBaseApplicationUrl() + temp.GraphicsFileUrl : null;
            return temp;
        })
        if (data.length > 0) data.sort((a, b) => a.Name.localeCompare(b.Name));
        AssemblyLibraryActions.setSelectedAssemblyTemplates(data)
        return data;
    },
    async createAssemblyTemplate() {
        if (AssemblyLibraryStore.getIsValidObject()) {
            if (!SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_ADD)) {
                SystemActions.beginAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_ADD);

                try {
                    const template = AssemblyLibraryStore.getAssemblyTemplateData();
                    let data = FormHelper.trim(template);
                    var form_data: any = new FormData();
                    form_data.append("ID", data.ID)
                    form_data.append("Name", data.Name)
                    form_data.append("LibraryID", data.LibraryID)
                    if (template.ThumbnailImageData) form_data.append("ThumbnailImageData", template.ThumbnailImageData, "thumbnail.png");
                    if (template.GraphicsFileData) form_data.append("GraphicsFileData", template.GraphicsFileData, "export.glb");
                    form_data.append("Scalable", data.Scalable)
                    form_data.append("Scale", data.Scale)
                    if (data.Origin) {
                        form_data.append("Origin.X", data.Origin.X)
                        form_data.append("Origin.Y", data.Origin.Y)
                        form_data.append("Origin.Z", data.Origin.Z)
                    }
                    form_data.append("VersionToken", data.VersionToken)

                    let res: any = await AssemblyLibraryServices.createAssemblyTemplate(form_data);
                    res = JSON.parse(res)

                    res.ThumbnailImageUrl = (res.ThumbnailImageUrl) ? UrlUtilities.getBaseApplicationUrl() + res.ThumbnailImageUrl : null;
                    res.GraphicsFileUrl = (res.GraphicsFileUrl) ? UrlUtilities.getBaseApplicationUrl() + res.GraphicsFileUrl : null;

                    AssemblyLibraryActions.setAssemblyTemplateData(res)
                    AssemblyLibraryActions.getAssemblyTemplates(data.LibraryID);
                    // refresh data
                    AssemblyLibraryActions._finishEdit(true);
                    return res;
                }
                finally {
                    SystemActions.endAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_ADD);
                }
            }
            else {
                //AssemblyLibraryActions._sendInvalidSave()
            }
        } else {
            _sendInvalidSave()
        }
    },
    async updateAssemblyTemplate() {
        if (AssemblyLibraryStore.getIsValidObject()) {
            if (!SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_UPDATE)) {
                SystemActions.beginAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_UPDATE);

                try {
                    const template = AssemblyLibraryStore.getAssemblyTemplateData();
                    let data = FormHelper.trim(template);
                    var form_data: any = new FormData();
                    form_data.append("ID", data.ID)
                    form_data.append("Name", data.Name)
                    form_data.append("LibraryID", data.LibraryID)
                    if (template.ThumbnailImageData) form_data.append("ThumbnailImageData", template.ThumbnailImageData, "thumbnail.png");
                    if (template.GraphicsFileData) form_data.append("GraphicsFileData", template.GraphicsFileData, "export.glb");
                    form_data.append("Scalable", data.Scalable)
                    form_data.append("Scale", data.Scale)
                    if (data.Origin) {
                        form_data.append("Origin.X", data.Origin.X)
                        form_data.append("Origin.Y", data.Origin.Y)
                        form_data.append("Origin.Z", data.Origin.Z)
                    }

                    form_data.append("VersionToken", data.VersionToken)

                    let res: any = await AssemblyLibraryServices.updateAssemblyTemplate(form_data);
                    res = JSON.parse(res)
                    res.ThumbnailImageUrl = (res.ThumbnailImageUrl) ? UrlUtilities.getBaseApplicationUrl() + res.ThumbnailImageUrl : null;
                    res.GraphicsFileUrl = (res.GraphicsFileUrl) ? UrlUtilities.getBaseApplicationUrl() + res.GraphicsFileUrl : null;
                    AssemblyLibraryActions.setAssemblyTemplateData(res)
                    AssemblyLibraryActions.getAssemblyTemplates(data.LibraryID);
                    // refresh data
                    AssemblyLibraryActions._finishEdit(true);
                    return res;
                }
                finally {
                    SystemActions.endAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_UPDATE);
                }
            } else {
                return;
            }
        } else {
            _sendInvalidSave()
        }
    },
    async deleteAssemblyTemplate(template: IAssemblyTemplate) {
        if (!SystemStore.isActionInProgress(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_DELETE)) {
            SystemActions.beginAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_DELETE);
            try {
                await AssemblyLibraryServices.deleteAssemblyTemplate(template);
                AssemblyLibraryActions.setAssemblyTemplateData(null);
                await AssemblyLibraryActions.getAssemblyTemplates(template.LibraryID);
            }
            finally {
                SystemActions.endAction(AssemblyLibraryConstants.ASSEMBLY_LIBRARY_TEMPLATE_DELETE);
            }
        }
    },
    editAssemblyTemplateProperty(key: string, value: any): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_TEMPLATE_UPDATE_EDIT,
            key: key,
            value: value
        });
    },
    setSelectedAssemblyLibrary(id: string) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.SET_SELECTED_ASSEMBLY_LIBRARY_ID,
            data: id
        });
    },
    setAssemblyTemplateData(data: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_TEMPLATE_SET_DATA,
            data: structuredClone(data)
        });
    },
    _finishEdit(isVisible: boolean = false) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: AssemblyLibraryConstants.ASSEMBLY_LIBRARY_FINISH_EDIT,
            isVisible
        });
    },

    _resetAssemblyTemplateData(): void {
        let template = AssemblyLibraryStore.getAssemblyTemplateData();
        if (template) {
            let selectedAssemblyTemplates = AssemblyLibraryStore.getAssemblyTemplates();
            let selectedTemplate = selectedAssemblyTemplates.find((temp) => temp.ID === template.ID);
            AssemblyLibraryActions.setAssemblyTemplateData(selectedTemplate);
        }
    },

    resetAssemblyTemplate(): void {
        if (AssemblyLibraryStore.getHasAssemblyTemplateChange()) {
            SystemActions.displayConfirmationMessage({
                message: InovxLoader.t('facility:message.resetPendingChanges'),
                confirmCallback: async () => {
                    AssemblyLibraryActions._resetAssemblyTemplateData();
                }
            });
        } else {
            AssemblyLibraryActions._resetAssemblyTemplateData();
        }
    },

    verifyAssemblyTemplateChanges(): boolean {
        if (AssemblyLibraryStore.getAssemblyLibraryVisible()) {
            if (AssemblyLibraryStore.getHasAssemblyTemplateChange()) {
                SystemActions.displayInfoMessage({
                    message: InovxLoader.t('facility:message.savePendingChangesInfo')
                });
                return false;
            }
        }
        return true;
    },
    verifyAndCloseAssemblyTemplateEdit(): boolean {
        var verified = true;
        if (AssemblyLibraryStore.getAssemblyLibraryVisible()) {
            verified = AssemblyLibraryActions.verifyAssemblyTemplateChanges();
            if (verified) {
                AssemblyLibraryActions._finishEdit(false);
            }
        }
        return verified;
    }
    
}

export default AssemblyLibraryActions;